import React from 'react';

import { sortOptions } from '@constants/catalog';
import { Button, Icon, Select, Option } from 'gd-design-library';

interface SortDropdownProps {
  value: string;
  onChange: (value) => void;
  className?: string
}

export const SortDropdown: React.FC<SortDropdownProps> = ({
  value,
  onChange,
  className
}) => (
  <Select
    className={ className }
    onChange={ (option: Option): void => onChange(option.value) }
    items={ sortOptions.map(({ value, label }) => ({ value, name: label })) }
    initiator={
      <Button variant='inherit' iconEnd={ <Icon name='arrowDown' width={ 24 } height={ 24 } /> }>
        Sort by: {sortOptions.find(option => option.value === value)?.label || ''}
      </Button>
    }
  />
);
